export default function NotificationSkeleton() {
  return (
    <div className="flex gap-3 border-b border-gray-100 animate-pulse">
      <div className="w-1" />

      <div className="py-2 flex flex-col gap-2 flex-1 pr-5">
        <div className="h-5 bg-gray-200 rounded w-3/4"></div>
        <div className="h-4 bg-gray-200 rounded w-full"></div>
        <div className="h-4 bg-gray-200 rounded w-5/6"></div>

        <div className="h-3 bg-gray-200 rounded w-24 mt-1"></div>
      </div>
    </div>
  );
}
